export default {
  TAGESDATUM: "8119d594-3479-481a-ad34-6f5415e91d10",
  SYAUSZAHLUNGBEZUGSDATUM: "17d353b4-4bb8-418f-abc9-1e3501c75bf6",
  GESCHAEFTSREGEL: "04450a1a-5ffd-459a-80bf-6476064be1ce",
};
